import { render, staticRenderFns } from "./PreferencesSettings.vue?vue&type=template&id=5ecd6999&scoped=true"
import script from "./PreferencesSettings.vue?vue&type=script&lang=js"
export * from "./PreferencesSettings.vue?vue&type=script&lang=js"
import style0 from "./PreferencesSettings.vue?vue&type=style&index=0&id=5ecd6999&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecd6999",
  null
  
)

export default component.exports